module.exports = __webpack_public_path__ + "img/layout_form_icon.b02e58a5.svg";